import {
  FileText,
  ShieldCheck,
  Briefcase,
  CreditCard,
  Copyright,
  Lock,
  AlertTriangle,
  RefreshCw,
} from "lucide-react";

const termsData = [
  {
    number: "01",
    title: "Acceptance of Terms",
    icon: FileText,
    description:
      "By accessing or using Web_Bocket's website, software solutions, or digital services, you acknowledge that you have read, understood, and agreed to comply with these Terms & Conditions. If you do not agree with any provision, you should discontinue the use of our services immediately.",
    points: [
      "Applies to every visitor and client.",
      "Acceptance is implied by continued use.",
      "Users must comply with all applicable laws.",
    ],
  },

  {
    number: "02",
    title: "Use of Services",
    icon: Briefcase,
    description:
      "Our software development, consulting, digital transformation, and IT services must only be used for lawful purposes. Users are responsible for ensuring that their activities do not violate any local, national, or international regulations.",
    points: [
      "No unlawful activities.",
      "No misuse of company resources.",
      "Services are intended for professional use.",
    ],
  },

  {
    number: "03",
    title: "Payments & Billing",
    icon: CreditCard,
    description:
      "All invoices, subscriptions, project payments, and commercial agreements must be completed according to the mutually agreed payment schedule. Delayed payments may result in suspension of services until outstanding balances are cleared.",
    points: [
      "Payments follow signed agreements.",
      "Invoices must be paid within the agreed timeline.",
      "Late payments may delay project delivery.",
    ],
  },

  {
    number: "04",
    title: "Intellectual Property",
    icon: Copyright,
    description:
      "Unless otherwise agreed in writing, all designs, software code, documentation, graphics, trademarks, and digital assets developed by Web_Bocket remain the intellectual property of the company until ownership is officially transferred under the project agreement.",
    points: [
      "Unauthorized copying is prohibited.",
      "Source code ownership follows the contract.",
      "Company branding cannot be reused without permission.",
    ],
  },

  {
    number: "05",
    title: "Confidentiality",
    icon: Lock,
    description:
      "Both Web_Bocket and its clients agree to maintain strict confidentiality regarding proprietary information, business strategies, source code, technical documentation, and project-related discussions.",
    points: [
      "Client information remains confidential.",
      "Sensitive project data is protected.",
      "Confidential information cannot be disclosed.",
    ],
  },

  {
    number: "06",
    title: "Security & Compliance",
    icon: ShieldCheck,
    description:
      "We implement industry-standard security practices to protect user information and digital assets. Users are responsible for maintaining the confidentiality of their own credentials and account access.",
    points: [
      "Strong security standards.",
      "User account protection.",
      "Compliance with applicable regulations.",
    ],
  },

  {
    number: "07",
    title: "Limitation of Liability",
    icon: AlertTriangle,
    description:
      "Web_Bocket shall not be liable for indirect, incidental, or consequential damages arising from the use or inability to use our website, software products, or professional services, except where required by applicable law.",
    points: [
      "Services are provided professionally.",
      "Liability is limited by contract.",
      "Applicable laws remain enforceable.",
    ],
  },

  {
    number: "08",
    title: "Updates to Terms",
    icon: RefreshCw,
    description:
      "These Terms & Conditions may be updated periodically to reflect changes in our services, business practices, or legal obligations. Continued use of our services constitutes acceptance of the revised terms.",
    points: [
      "Terms may change periodically.",
      "Updated versions become effective immediately.",
      "Users are encouraged to review this page regularly.",
    ],
  },
];

export default termsData;